export default __webpack_public_path__ + "static/media/saskia4.f7b08390.jpg";